module.exports = __webpack_public_path__ + "static/img/Main-Banner3.c905b47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banners/Main-Banner3.jpg
// module id = uQOE
// module chunks = 1